/*
* Product Image ScrollTo Interaction
*
**/

// import 'slick-carousel';
// Google Tag Manager DataLayer Helper
require('custom/gtm-datalayer');

custom.collectionCard = (function() {

  var breakpoint = 768;
  var timeout = 250; // Debounce
  var timer = [];
  var windowWidth = $(window).width();
  var imgChangeClass = "fade-in-fast";
  var mobileConfig = {
    infinite: true,
    dots: true,
    arrows: false,
    lazyLoad: 'anticipated'
    // slide: ".collection-card__thumbnail"
  };
  var desktopConfig = {
    infinite: false,
    dots: false,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    // slide: ".collection-card__thumbnail",
    lazyLoad: 'ondemand',
    prevArrow: '<button type="button" class="collection-card__carousel-arrow slick-prev"></button>',
    nextArrow: '<button type="button" class="collection-card__carousel-arrow slick-next"></button>'
  };

  let preloadImgs = {};

  function isMobile() {
    return $(window).width() < breakpoint;
  }

  function isInitialized($el) {
    return $el.hasClass('slick-initialized');
  }

  function getThumbnailsContainer(id) {
    return $("#" + id).find('.collection-card__thumbnails');
  }

  function cancelPageJump(event) {
    var $target = $(event.target);
    if($target.hasClass('slick-arrow') ||  $target.hasClass('collection-card__thumbnail-img')) return false;
  }

  function changeImage($el={}, productHandle="") {
    requestAnimationFrame(function(){
      (preloadImgs[productHandle]) ? $el.attr('srcset', preloadImgs[productHandle].src) : $el.attr('srcset', $el.data("img-large"));
      $el.addClass(imgChangeClass);
      setTimeout(()=>{ $el.removeClass(imgChangeClass); }, 300);
    });
  }

  function preloadHoverImage(e={}, $thumbs={}) {
    $.each($thumbs, (index, thumb) => {
      let _thumbImg = new Image();
      _thumbImg.src = $(thumb).find("img").data("img-large");
      preloadImgs[$(thumb).data("handle")] = _thumbImg;
    });
  }

  function imgChangeHandler($el) {
    var $thumbArr = $el.find('.collection-card__thumbnail');
    var $card = $el.closest('.collection-card');
    var $imgContainer = $card.find('.collection-card__image-container');
    var $mainImg = $card.find('.collection-card__image').prev("source");

    // Click Cancelation on certain element inside card
    $imgContainer.on('click', cancelPageJump);

    $.each($thumbArr, function(index, thumb) {
      const productHandle = $(thumb).data("handle");
      $(thumb).find('img').on('mouseover touch', function(){
        changeImage($mainImg, productHandle);
      });
    });

    if (!custom.utils.mobileAndTabletcheck()) $card.on('mouseenter', e => preloadHoverImage(e, $thumbArr));
  }

  function currentSlideClassToggle($el) {
    $el.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      if(currentSlide == 0) {
        $el.addClass('slick-end');
      } else {
        $el.removeClass('slick-end');
      }
    });
  }

  function insertNumOfTheRest(handle=null) {
    if(!$(`#${handle}`).find('.collection-card__count')) return;
    const num = parseInt($(`#${handle}`).find('.collection-card__count').text().replace(' Designs', ''));

    if (num-6 > 0) {
      const $nextArrow = $(`#${handle}`).find('.slick-next');
      const urlstr = $(`#${handle}`).find('.collection-card__collection').attr('href');
      $(`<a href="${urlstr}" class="collection-card__more">+` + (num-6) + '</a>').insertAfter($nextArrow);
    }
  }

  function deleteNumOfTheRest(handle=null) {
    return ($(`#${handle}`).find('.collection-card__more'))? $(`#${handle}`).find('.collection-card__more').remove() : false;
  }

  function slickHandler(handle=null, event=null) {
    const $el = getThumbnailsContainer(handle);
    if(event == null && isInitialized($el)) return;

    if(isInitialized($el)) {
      $el.slick('unslick');
      $el.off('afterChange');
    }
    if(isMobile()) {
      deleteNumOfTheRest(handle);
      $el.slick(mobileConfig);
    } else {
      $el.slick(desktopConfig);
      currentSlideClassToggle($el);
      imgChangeHandler($el);
      insertNumOfTheRest(handle);
    }
    //add GTM tracking to carousel slides
    $el.on('afterChange', function (event, slick, currentSlide) {
      const data = {
        eventCategory: custom.utils.titleCase(handle),
        eventAction: 'Carousel',
        eventLabel: 'Slide ' + currentSlide
      }
      custom.gtmDatalayer.gtmPush(data);
    });
  }

  function designsCountChange(id) {
    var collectionCardCountElement = document.querySelector("#" + id + " .collection-card__count")
    if (collectionCardCountElement) {
      var cardCountWords = collectionCardCountElement.innerText.split(' ');

      if (cardCountWords[0] == '1' && cardCountWords[1] == 'Designs') {
        collectionCardCountElement.innerText = collectionCardCountElement.innerText.slice(0, -1);
      }
    }
  }

  function init(id) {
    slickHandler(id);
    $(window).on('resize', (event) => {
      var currentWindowWidth = $(window).width();

      if (currentWindowWidth != windowWidth) {
        clearTimeout(timer[id]);
        timer[id] = setTimeout(()=>{slickHandler(id, event);}, timeout);

        windowWidth = currentWindowWidth;
      }

    });

    designsCountChange(id);
  }

  return {
    init: init
  }

})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/collection-card.js